import { Component, h, Listen, Prop } from '@stencil/core'
import { ListingProduct } from '@rdss/client'

@Component({
    tag: 'zr-bannerx-slider',
    styleUrl: 'zr-bannerx-slider.scss',
    shadow: true,
})

/**
 * ZooRoyal Banner X Slider.
 */
export class ZrBannerxSlider {
    /**
     * The banner X products.
     */
    @Prop() products: ListingProduct[]

    /**
     * The CTA text.
     */
    @Prop() ctaText: string

    /**
     * The CTA link.
     */
    @Prop() ctaLink: string

    /**
     * The CTA text accessibility.
     */
    @Prop() ctaTextAccessibility: string

    /**
     * The citrus ad id.
     */
    @Prop() citrusAdId: string

    /**
     * Element reference to the scroller.
     */
    private slider: HTMLElement

    /**
     * Scroll the tile into view.
     */
    scrollTileIntoView = (tile: HTMLElement) => {
        if (tile) {
            this.slider.scrollTo({ left: tile.offsetLeft, behavior: 'smooth' })
        }
    }

    /**
     * Handle the click event on the prev button.
     */
    @Listen('bannerxPrevClick', { target: 'window' })
    handlePrevClick() {
        const tile = Array.from(this.slider.querySelectorAll('zr-product-tile'))
            .filter((tile: HTMLElement) => (tile.offsetLeft - this.slider.scrollLeft < 0))
            .pop()
        this.scrollTileIntoView(tile)
    }

    /**
     * Handle the click event on the next button.
     */
    @Listen('bannerxNextClick', { target: 'window' })
    handleNextClick() {
        const tile = Array.from(this.slider.querySelectorAll('zr-product-tile, zr-bannerx-cta'))
            .filter((tile: HTMLElement) => (tile.offsetLeft - this.slider.scrollLeft > 0))
            .shift()
        this.scrollTileIntoView(tile as HTMLElement)
    }

    /**
     * Renders the component.
     */
    render() {
        return (this.products && this.products.length > 0) && (
            <div class="zr-bannerx-slider__wrapper" ref={el => (this.slider = el)}>
                <div class="zr-bannerx-slider__slider">
                    {this.products.map(product => (
                        <zr-product-tile
                            key={product.sku}
                            product={{ citrusAdId: this.citrusAdId, ...product }}
                            context={'showroom-ad'}
                        />
                    ))}
                    <zr-bannerx-cta
                        ctaText={this.ctaText}
                        ctaLink={this.ctaLink}
                        ctaTextAccessibility={this.ctaTextAccessibility}
                    />
                </div>
            </div>
        )
    }
}
